// extracted by mini-css-extract-plugin
export default {"content":"GroupLessonReportTable_content__VSyCm"};